var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center iframe-container"},[_c('custom-iframe',{attrs:{"src":_vm.src,"width":_vm.width,"height":_vm.height,"padding-bottom":_vm.paddingBottom}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }